import { IndexedInventory } from "types/inventory";
import { useReactToPrint } from "react-to-print";
import Printable from "components/Printable";
import PrintableQRCodes from "components/Pickups/PrintableQRCodes";
import React, { useRef } from "react";
import PrintIcon from "@mui/icons-material/Print";
import { useGridApiContext } from "@mui/x-data-grid-pro";
import { GridBulkActionsItem } from "components/DataGrid/components/GridBulkActionsItem";

// React Print requires us to initiate the print modal from the click directly, so we have to use a custom menu item
// vs dispatching an event.
export const GridBulkPrintActionItem = () => {
  const apiRef = useGridApiContext();
  const printComponentRef = useRef<HTMLDivElement | null>(null);
  const selectedInventories = Array.from(apiRef.current.getSelectedRows().values()) as IndexedInventory[];
  const handlePrint = useReactToPrint({
    contentRef: printComponentRef,
    onAfterPrint: () => {
      dispatchEvent(new CustomEvent("bulkPrint", { detail: { selectedRows: selectedInventories } }));
    },
  });

  return (
    <>
      <GridBulkActionsItem label={"Print"} icon={<PrintIcon />} onClick={() => handlePrint()} />
      <Printable>
        <PrintableQRCodes selectedInventories={selectedInventories} ref={printComponentRef} />
      </Printable>
    </>
  );
};
